import PropTypes from 'prop-types';

const Toggleable = (props) => {
  const { children, show } = props;
  if (show) {
    return <>{children}</>;
  }
  return <></>;
};

Toggleable.defaultProps = {
  show: true,
};

Toggleable.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  show: PropTypes.bool,
};

export default Toggleable;
